import type { PropsWithChildren, ReactElement } from 'react';
import type {
  IBondScreenerViewsResponse,
  TBondScreenerType,
  TFilterPayload,
} from '@/creditflowresearch/domain/vo/Bondscreener';
import { BondScreenerViewsContext } from '@/creditflowresearch/application/BondScreener/Sidebar/BondScreenerViewsContext';
import useBondScreenerViews from './useBondScreenerViews';

interface ICorporateBondScreenerViewsProviderProps extends PropsWithChildren {
  type: TBondScreenerType,
  initialViews: IBondScreenerViewsResponse<TFilterPayload>,
}

export const CorporateBondScreenerViewsProvider = ({
  children,
  type,
  initialViews,
}: ICorporateBondScreenerViewsProviderProps): ReactElement => (
  <BondScreenerViewsContext.Provider value={ useBondScreenerViews({ type, initialViews }) }>
    { children }
  </BondScreenerViewsContext.Provider>
);
